import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

/**
 * FormSection
 * Classification: custom
 *
 * Groups related form fields under a titled, described section with consistent
 * spacing - the building block for composite forms (Settings, create flows).
 */
export interface FormSectionProps {
  title: string;
  description?: string;
  children: ReactNode;
  /** Renders a divider above the section. */
  divider?: boolean;
}

export function FormSection({ title, description, children, divider = false }: FormSectionProps) {
  return (
    <Box component="section" sx={{ py: 2 }}>
      {divider ? <Divider sx={{ mb: 3 }} /> : null}
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle1">{title}</Typography>
        {description ? (
          <Typography variant="body1" color="text.secondary">
            {description}
          </Typography>
        ) : null}
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 520 }}>{children}</Box>
    </Box>
  );
}
